import React, { useState } from 'react';
// import PropTypes from 'prop-types';
import { Box, Text, Grid } from 'wt-ui';

import AlertMe from './AlertMe';
import EventDetails from './EventDetails';
import TextWithTooltip from './TextWithTooltip';
import Units from './Units';

const ChildHeader = ({ toggleContent, event }) => (
  <Grid columns={['flex', '250px']} background="transparent" direction="row">
    <Box background="transparent" pad={{ left: 'small' }} hoverEffect>
      <TextWithTooltip toggleContent={toggleContent} event={event} />
    </Box>
    <Grid columns={['flex', '50px']}>
      <Grid columns={['1/3', '1/3', '1/3']}>
        <Box background="transparent">{event.value}</Box>
        <Box background="transparent">{event.prevValue}</Box>
        <Box background="transparent">
          <Units units={event.enum.units} shortUnits={event.enum.shortUnits} />
        </Box>
      </Grid>
      <Box background="transparent">
        <AlertMe event={event} />
      </Box>
    </Grid>
  </Grid>
);

const ChildRow = ({ event, isLast }) => {
  const [isOpen, setIsOpen] = useState(false);
  const style = {};
  if (isOpen) {
    // style.boxShadow = '0 0 10px #a6a6a6';
    style.boxShadow = 'rgb(166, 166, 166) 1px 4px 6px -2px';
    style.background = '#e2e2e224';
  }
  // boxShadow: '0 0 10px #a6a6a6',
  // isLast ? {} : { borderBottom: '1px solid grey' }
  return (
    <Box background="transparent" pad={{ top: 'small', bottom: 'small' }} style={style}>
      <ChildHeader toggleContent={() => setIsOpen(!isOpen)} event={event} />
      {isOpen ? <RowContent event={event} noDate /> : ''}
    </Box>
  );
};

const RowContent = ({ event, noDate }) => {
  console.log('RowContent', event);
  const columns = !noDate ? ['xsmall', 'flex', 'small'] : ['flex', 'small'];
  return (
    <>
      <Grid columns={columns} background="transparent" direction="row">
        {!noDate ? <Box background="transparent" /> : ''}
        <Box background="transparent" pad={{ left: 'small' }}>
          <Text margin={{ top: 'small', bottom: 'small' }}>{event.description || event.enum.description}</Text>
          <Text margin={{ top: 'small', bottom: 'small' }}>
            <span style={{ fontWeight: 600 }}>Source:</span> {event.source || event.enum.displaySource || event.enum.source}
          </Text>

          <Box background="transparent">
            {event.children && event.children.length > 0 ? '' : <EventDetails event={event} />}
          </Box>
        </Box>
      </Grid>
      <Grid columns={['xsmall', 'flex']} background="transparent" direction="row" margin={{ top: 'small' }}>
        <Box background="transparent" />
        <Box background="transparent">
          {event.children && event.children.length > 0
            ? event.children.map((child, index) => (
                <ChildRow key={child.id} event={child} isLast={index === event.children.length - 1} />
            ))
            : ''}
        </Box>
      </Grid>
    </>
  );
};

export default RowContent;
